import {FlexboxProps} from '../flexbox/FlexBox'
import {StyledConfirmationDialogAccordionContainer} from './style'

export const ConfirmationDialogAccordionContainer = (props: FlexboxProps<'div'>) => (
    <StyledConfirmationDialogAccordionContainer {...props} />
)
